module.exports = __webpack_public_path__ + "img/body-boxes-signs.817660e8.png";